(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ft-reiseblog-listing"]) return;
  try {
    
  (function () {
    var GAP = 20;
    var resizeTimer;

    function getColCount() {
      if (window.innerWidth >= 1024) return 3;
      if (window.innerWidth >= 600) return 2;
      return 1;
    }

    function masonry(grid) {
      var items = Array.from(grid.querySelectorAll('.ft-reiseblog__item:not([hidden])'));
      if (!items.length) { grid.style.height = '0'; return; }

      var cols = getColCount();
      var totalW = grid.clientWidth;
      var colW = (totalW - GAP * (cols - 1)) / cols;
      var tops = new Array(cols).fill(0);

      items.forEach(function (item) {
        var col = tops.indexOf(Math.min.apply(null, tops));
        item.style.width = colW + 'px';
        item.style.left = (col * (colW + GAP)) + 'px';
        item.style.top = tops[col] + 'px';
        tops[col] += item.offsetHeight + GAP;
      });

      grid.style.height = Math.max.apply(null, tops) + 'px';
    }

    function initSection(container) {
      var grid = container.querySelector('.ft-reiseblog__masonry');
      if (!grid) return;

      masonry(grid);

      var filters = container.querySelector('.ft-reiseblog__filters');
      if (!filters) return;

      var pills = filters.querySelectorAll('.ft-reiseblog__pill');
      var items = grid.querySelectorAll('.ft-reiseblog__item[data-tags]');

      filters.addEventListener('click', function (e) {
        var pill = e.target.closest('.ft-reiseblog__pill');
        if (!pill) return;

        var filter = pill.dataset.filter;

        pills.forEach(function (p) {
          p.classList.remove('ft-reiseblog__pill--active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('ft-reiseblog__pill--active');
        pill.setAttribute('aria-pressed', 'true');

        items.forEach(function (item) {
          if (filter === '*') {
            item.hidden = false;
          } else {
            var tags = item.dataset.tags ? item.dataset.tags.split(' ') : [];
            item.hidden = !tags.includes(filter);
          }
        });

        masonry(grid);
      });
    }

    // Debounced resize: 100 ms nach dem letzten Event, fresh querySelector
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var grid = document.querySelector('.ft-reiseblog__masonry');
        if (grid) masonry(grid);
      }, 100);
    });

    // Shopify Theme Editor: Section neu initialisieren nach jedem Re-Render
    document.addEventListener('shopify:section:load', function (e) {
      initSection(e.target);
    });

    // Erster Seitenaufruf
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSection(document); });
    } else {
      initSection(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
